/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Type_EmptyInputs */



/**
* | output |
* | --- |
* | "There are no conversation types yet." |
*
* @param {Meeting_Prep_Type_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_type_empty = /** @type {((inputs?: Meeting_Prep_Type_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Type_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Er zijn nog geen gesprekstypes.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Il n'y a pas encore de types de conversation.")
	return /** @type {LocalizedString} */ ("There are no conversation types yet.")
});